import React, { useState } from 'react';
import {
    Tabs, TabList, TabPanels, TabPanel, Tab, Button, Slider, SliderTrack,
    SliderFilledTrack, SliderThumb, Box, Text, useColorModeValue, Input, FormLabel, VStack, FormControl, Select, Flex
} from '@chakra-ui/react';

const TimeRangeSelector = ({ onRangeSave, maxDayRange }) => {
    const [dayStart, setDayStart] = useState(0);
    const [dayEnd, setDayEnd] = useState(maxDayRange);
    const [selectedDay, setSelectedDay] = useState(0);
    const [hourStart, setHourStart] = useState(0);
    const [hourEnd, setHourEnd] = useState(23);
    const [activeTab, setActiveTab] = useState(0);

    const handleSave = () => {
        if (dayStart <= dayEnd && hourStart <= hourEnd) {
            onRangeSave(activeTab, { dayStart, dayEnd }, { selectedDay, hourStart, hourEnd });
        } else {
            alert("Invalid range selected.");
        }
    };

    const createDayOptions = () => {
        let options = [];
        for (let i = 0; i <= maxDayRange; i++) {
            options.push(<option key={i} value={i}>{i}</option>);
        }
        return options;
    };

    const handleTabChange = (tabIndex) => {
        setActiveTab(tabIndex);
    }

    const tabColor = useColorModeValue("gray.200","gray.600");

    return (
        <Tabs  variant={"enclosed"} colorScheme='green' width={"100%"} boxShadow={"xl"} index={activeTab} onChange={handleTabChange}>
            <TabList >
                <Tab>Days</Tab>
                <Tab >Hours</Tab>

            </TabList>

            <TabPanels  >

                <TabPanel borderLeft={"1px"} borderRight={"1px"} borderBottom={"1px"}  borderColor={tabColor}>
                    <Flex direction="column" gap={4}>
                        <Flex>
                            <FormControl mr={2}>
                                <FormLabel>From Day</FormLabel>
                                <Input type="number" value={dayStart} onChange={(e) => setDayStart(Math.min(Math.max(0, Number(e.target.value)), maxDayRange))} />
                            </FormControl>
                            <FormControl ml={2}>
                                <FormLabel>To Day</FormLabel>
                                <Input type="number" value={dayEnd} onChange={(e) => setDayEnd(Math.min(Math.max(0, Number(e.target.value)), maxDayRange))} />
                            </FormControl>
                        </Flex>

                        <Box>
                            <Button colorScheme="blue" onClick={handleSave}>Save</Button>
                        </Box>

                    </Flex>
                </TabPanel>
                <TabPanel borderLeft={"1px"} borderRight={"1px"} borderBottom={"1px"}  borderColor={tabColor}>
                    <Box mb={4}>
                        <FormControl>
                            <FormLabel>Select Day</FormLabel>
                            <Select value={selectedDay} onChange={(e) => setSelectedDay(Number(e.target.value))}>
                                {createDayOptions()}
                            </Select>
                        </FormControl>
                    </Box>
                    <Flex align="center" justify="space-between" mb={4}>
                        <FormControl mr={2}>
                            <FormLabel>From Hour</FormLabel>
                            <Input type="number" value={hourStart} onChange={(e) => setHourStart(Math.min(Math.max(0, Number(e.target.value)), 23))} />
                        </FormControl>
                        <FormControl ml={2}>
                            <FormLabel>To Hour</FormLabel>
                            <Input type="number" value={hourEnd} onChange={(e) => setHourEnd(Math.min(Math.max(0, Number(e.target.value)), 23))} />
                        </FormControl>
                    </Flex>
                    <Button colorScheme="blue" onClick={handleSave}>Save</Button>
                </TabPanel>
            </TabPanels>
        </Tabs>
    );
};

export default TimeRangeSelector;
